import {formatDate} from '../../../helpers/utils';

export const COMMON_REQ = 'cris/approveWorkOrder/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/approveWorkOrder/COMMON_REQ_FAIL';

export const LOAD_APPROVE_WORK_ORDERS_REQ = 'cris/approveWorkOrder/LOAD_APPROVE_WORK_ORDERS_REQ';
export const SUBMIT_APPROVE_WORK_ORDERS_REQ = 'cris/approveWorkOrder/SUBMIT_APPROVE_WORK_ORDERS_REQ';

const initialState = {
	isLoading: false,
	error: null,
	approveWorkOrders: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_APPROVE_WORK_ORDERS_REQ:
			const approveWorkOrders = action.payload.data.work_orders.map((item) => ({
				id: item.id,
				code: item.code,
				type: item.type,
				revision: item.revision,
				prr_ncn: item.prr_ncn || '',
				job_description: item.job_description,
				start_date: item.start_date,
				formattedStartDate: formatDate(item.start_date),
				old_code: item.old_code || '',
				customerName: item.customer ? item.customer.name : '',
				jobLocationName: item.job_location ? item.job_location.name : ''
			}));

			return {
				...state,
				isLoading: false,
				approveWorkOrders: approveWorkOrders
			};

		case SUBMIT_APPROVE_WORK_ORDERS_REQ:
			const newApproveWorkOrders = state.approveWorkOrders.filter(item => item.id !== action.payload.workOrderId);

			return {
				...state,
				isLoading: false,
				approveWorkOrders: newApproveWorkOrders
			};

		default:
			return state;
	}
}